export const channelInitialState = {
  channelUpdateInputs: {},
  currentProject: {},
  currentChannel: {},
  currentChannelVideo: {},
};
